// yang belom di kerjadkan:
// a.text lebih jelas dan interaktif!
// b.Animasi text entry
import { React } from "react";
import { useState, useEffect } from "react";
import Carousel from "react-bootstrap/Carousel";
import Image from "react-bootstrap/Image";
import "../animation.css";
import "./Component.css";

const Sambutanvid = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Attach the event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };
  const all_carousel = [
    {
      img: "https://i.ibb.co.com/Npcm5Ct/wecarcare.webp",
      interval: 4500,
      h1: "Bosan keliling cari bengkel yang bisa semuanya?",
      p: "Servis rutin, konsultasi, jual-beli mobil bekas – selesai di RPM. Satu tempat, tanpa bolak-balik.",
      cta: "Lihat Layanan Lengkap",
      link: "/consultation",
    },
    {
      img: "https://i.ibb.co.com/Q89Ny03/mobil-we.webp",
      interval: 4500,
      h1: "Pernah ditagih servis tanpa penjelasan jelas?",
      p: "Kami bekerja dengan data, bukan tebakan. Transparan, jujur, dan berbasis fakta sejak 2019.",
      cta: "Cek Keunggulan Kami",
      link: "#why-us",
    },
    {
      img: "https://i.ibb.co.com/cgMDvsz/Coating-image.jpg",
      interval: 4500,
      h1: "Mobilmu punya karakter. Perawatannya juga harus begitu.",
      p: "Kami tidak hanya ikut SOP. Kami mendengar, merasakan, dan merawat sesuai gaya berkendaramu.",
      cta: "Rasakan Layanan Berbeda",
      link: "/detailing&coating-info",
    },
    {
      img: "https://i.ibb.co.com/kgdkfrx/interior.webp",
      interval: 4500,
      h1: "Cari tempat yang paham selera dan gairah otomotifmu?",
      p: "RPM adalah rumah bagi pria yang ingin kendaraannya selalu prima, tanpa drama, tanpa basa-basi.",
      cta: "Konsultasi Gratis Sekarang",
      link: "https://wa.me/6281932536022",
    },
  ];

  return (
    <>
      <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        fade={true}
        controls={false}
        keyboard={true}
      >
        {all_carousel.map((item, i) => {
          return (
            <Carousel.Item
              style={{
                height: isMobile ? "95vh" : "100vh",
                backgroundColor: "#000",
              }}
              key={i}
              interval={item.interval}
            >
              <Image
                src={item.img}
                style={{
                  width: "100%",
                  height: isMobile ? "95vh" : "100vh",
                  objectFit: isMobile ? "contain" : "cover",
                }}
              />
              <Carousel.Caption
                style={{
                  textAlign: isMobile ? "center" : "start",
                  bottom: isMobile ? "220px" : "150px",
                  left: isMobile ? "10%" : "5%",
                  maxWidth: isMobile ? "80%" : "700px",
                }}
              >
                <h1
                  style={{
                    fontSize: isMobile ? "26px" : "4.5vw",
                    textShadow: "5px 5px 15px #000",
                    backdropFilter: "blur(3px)",
                    marginBottom: "20px",
                    opacity: "0",
                  }}
                  className="roleway animation-down-top"
                >
                  {item.h1}
                </h1>

                <h3
                  style={{
                    fontSize: isMobile ? "16px" : "1.8vw",
                    backdropFilter: "blur(3px)",
                    textShadow: "5px 5px 15px #000",
                    marginBottom: "30px",
                    opacity: "0",
                    lineHeight: "1.4",
                  }}
                  className="roleway animation-h3-sambutan"
                >
                  {item.p}
                </h3>

                <div
                  className="animation-span-3"
                  style={{ opacity: "0", marginTop: "20px" }}
                >
                  <a
                    href={item.link}
                    style={{
                      color: "#ff0000",
                      fontSize: isMobile ? "18px" : "2vw",
                      textDecoration: "none",
                      fontWeight: "bold",
                      borderBottom: "2px solid #ff0000",
                      paddingBottom: "5px",
                      cursor: "pointer",
                    }}
                    className="roleway"
                  >
                    {item.cta} <i className="bi bi-arrow-right"></i>
                  </a>
                </div>
              </Carousel.Caption>
            </Carousel.Item>
          );
        })}
      </Carousel>
    </>
  );
};

export default Sambutanvid;
